import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { api } from './api'

export default function Login({ onSignedIn }) {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  async function submit(event) {
    event.preventDefault()
    setBusy(true)
    setError(null)

    try {
      // The antiforgery pair has to exist before the first POST from a fresh browser.
      await api.prime()
      onSignedIn(await api.login(email, password))
    } catch (failure) {
      setError(failure.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="center">
      <form className="card login" onSubmit={submit}>
        <img className="login__logo" src="/logo.png" alt="Dosegni" />
        <p className="login__tag">{t('app.title')}</p>

        <label>
          {t('login.email')}
          <input
            type="email"
            required
            autoComplete="username"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>

        <label>
          {t('login.password')}
          <input
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>

        <button type="submit" className="button" disabled={busy}>
          {busy ? t('login.working') : t('login.signIn')}
        </button>

        {error && <p className="status bad">{error}</p>}
      </form>
    </div>
  )
}
